import { LoginState } from '@pages/login/store/state/login.state';
import { CompanyLoginSsoState } from '@pages/login/store/state/company-login-sso.state';
import { LogInWithThirdPartySsoState } from '@pages/login/store/state/log-in-with-third-party-sso.state';

export const loginState = [LoginState, CompanyLoginSsoState, LogInWithThirdPartySsoState];
